import DialogActionButtonsSection from './components/DialogActionButtonsSection'
import { useContext } from 'react'
import { AudioInputSelection } from '../UserContext'
import { AppContext, AppContextType } from '../AppContext'
import useMediaSelectionActions from '../actions/useMediaSelectionActions'
import { AudioEngineLocalStreamStats } from '../core/AudioEngine'
import CrossPlatformDialog from './components/CrossPlatformDialog'
import { DialogBody, DialogTitle } from '@/components/Dialog'

export default function AudioEngineStreamUnresponsiveDialogController() {
    const { state: appState, dispatch: appDispatch } = useContext(AppContext) as AppContextType

    const onClose = () => {
        appDispatch({
            type: 'update_app_state',
            value: { showAudioEngineStreamUnresponsiveDialog: null },
        })
    }

    if (appState.appState.showAudioEngineStreamUnresponsiveDialog) {
        const { selection, stats } = appState.appState.showAudioEngineStreamUnresponsiveDialog
        return (
            <CrossPlatformDialog
                frameName={`Dialog:AudioEngineSampleRateMismatchDialogController`}
                onDefaultClose={() => onClose()}
            >
                <Content selection={selection} stats={stats} onClose={() => onClose()} />
            </CrossPlatformDialog>
        )
    } else {
        return null
    }
}

function Content({
    selection,
    stats,
    onClose,
}: {
    selection: AudioInputSelection
    stats: AudioEngineLocalStreamStats
    onClose: () => void
}) {
    const { reloadAudioDeviceSelection } = useMediaSelectionActions()

    const onReload = () => {
        reloadAudioDeviceSelection(selection)
    }

    return (
        <div className="w-full">
            <DialogBody>
                <DialogTitle>Unresponsive audio device</DialogTitle>

                <div>
                    We are no longer receiving audio from{' '}
                    <span className="text-muse-yellow">{selection.source.displayLabel}</span>.
                </div>
            </DialogBody>
            <DialogActionButtonsSection
                leftButtonText="Reload device"
                rightButtonText="OK"
                onLeftButtonClicked={() => {
                    onReload()
                    onClose()
                }}
                onRightButtonClicked={() => {
                    onClose()
                }}
            />
        </div>
    )
}
